import { ArrowRight, Sprout, Target } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";

export function About() {
  return (
    <section id="about" className="relative overflow-hidden bg-gradient-to-br from-green-50 via-white to-emerald-50 py-24 md:py-32">
      <div className="mx-auto grid max-w-7xl gap-16 px-5 md:px-8 lg:grid-cols-2 lg:gap-20">
        {/* Image collage */}
        <Reveal>
          <div className="relative h-[480px] md:h-[600px]">
            <div className="absolute left-0 top-0 h-3/4 w-3/4 overflow-hidden rounded-3xl shadow-lg">
              <img src="/images/who we are.jpg" alt="TEV Africa Foods Operations" className="h-full w-full object-cover" loading="lazy" />
            </div>
            <div className="absolute bottom-0 right-0 h-2/3 w-2/3 overflow-hidden rounded-3xl border-8 border-white shadow-lg">
              <img src="/images/process.jpg" alt="Modern food facility" className="h-full w-full object-cover" loading="lazy" />
            </div>
            <div className="absolute -bottom-6 left-4 z-10 flex items-center gap-3 rounded-2xl bg-white px-5 py-4 shadow-lg md:left-12">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-r from-green-500 to-green-600 text-white">
                <Sprout className="h-5 w-5" />
              </div>
              <div>
                <div className="font-display text-2xl font-medium leading-none">100%</div>
                <div className="mt-1 text-xs font-medium text-gray-600">African Sourced</div>
              </div>
            </div>
          </div>
        </Reveal>

        {/* Content */}
        <Reveal delay={0.15}>
          <div className="flex h-full flex-col justify-center">
            <span className="text-xs font-semibold uppercase tracking-[0.22em] text-green-600">
              About TEV Africa Foods
            </span>
            <h2 className="mt-4 text-balance font-display text-4xl leading-tight tracking-tight md:text-5xl lg:text-6xl">
              Rooted in Africa.<br />
              <span className="italic text-green-600">Trusted</span> worldwide.
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-gray-600">
              Our focus is on food value chains. Through this, our business exists to solve one of the most consequential of human needs. We are therefore committed to contributing to Africa's food security.
            </p>
            <p className="mt-4 text-lg leading-relaxed text-gray-600">
              From seed propagation, irrigated agriculture, agro-processing and value addition, we intend to be a dependable partner in the production of high quality, safe and nutritious food products.
            </p>

            <div className="mt-8 rounded-2xl border border-gray-200 bg-white p-6 shadow-md">
              <div className="flex items-start gap-4">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-green-500 text-white">
                  <Target className="h-5 w-5" />
                </div>
                <div>
                  <h3 className="font-display text-lg">Our Mission</h3>
                  <p className="mt-1 text-sm leading-relaxed text-gray-600">
                    Our mission is to leverage our resources and capabilities to contribute towards food security at local, national and regional level, in a manner that is sustainable.
                  </p>
                </div>
              </div>
            </div>

            <Link
              to="/about"
              className="group mt-8 inline-flex w-fit items-center gap-2 rounded-full bg-green-500 px-6 py-3.5 text-sm font-medium text-white shadow-lg transition-transform hover:scale-[1.03]"
            >
              Learn More About Us
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
